const ZOOM_JOIN_URL_ID = /\/j\/(\d{9,11})(?:[/?#]|$)/;

export function parseZoomWebinarId(joinUrl: string): number | null {
  const match = joinUrl.trim().match(ZOOM_JOIN_URL_ID);
  if (!match) {
    return null;
  }
  return Number(match[1]);
}
